const initTimelineAutoplay = () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const AUTOPLAY_DELAY = 3000;

  document.querySelectorAll('.timeline').forEach((timeline) => {
    const carousel = timeline.querySelector('timeline-carousel');
    const navigation = timeline.querySelector('carousel-navigation');

    if (!carousel || !navigation) return;

    const buttons = Array.from(
      navigation.querySelectorAll('button[aria-current]')
    );

    if (buttons.length < 2) return;

    let timer = null;
    let isVisible = false;
    let isPaused = false;

    const stop = () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    };

    const scheduleNext = () => {
      stop();

      if (!isVisible || isPaused) return;

      timer = setTimeout(() => {
        const currentIndex = buttons.findIndex(
          (button) => button.getAttribute('aria-current') === 'true'
        );

        const nextIndex =
          currentIndex === -1
            ? 0
            : (currentIndex + 1) % buttons.length;

        buttons[nextIndex].click();

        scheduleNext();
      }, AUTOPLAY_DELAY);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isVisible = entry.isIntersecting;

          if (isVisible) {
            scheduleNext();
          } else {
            stop();
          }
        });
      },
      {
        threshold: 0.3
      }
    );

    observer.observe(timeline);

    timeline.addEventListener('mouseenter', () => {
      isPaused = true;
      stop();
    });

    timeline.addEventListener('mouseleave', () => {
      isPaused = false;
      scheduleNext();
    });

    timeline.addEventListener('focusin', () => {
      isPaused = true;
      stop();
    });

    timeline.addEventListener('focusout', () => {
      isPaused = false;
      scheduleNext();
    });

    timeline.addEventListener(
      'touchstart',
      () => {
        isPaused = true;
        stop();
      },
      { passive: true }
    );

    timeline.addEventListener(
      'touchend',
      () => {
        isPaused = false;
        scheduleNext();
      },
      { passive: true }
    );

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        if (!event.isTrusted) return;

        isPaused = false;
        scheduleNext();
      });
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTimelineAutoplay);
} else {
  initTimelineAutoplay();
}